import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {
  getAccessToken,
  redirectToLoginPage,
  parseAuthQueryString,
  handleAuthentication,
} from "./auth";

const root = ReactDOM.createRoot(document.getElementById("root"));

if (window.appSettings.isOidc) {
  root.render(<App />);
} else {
  (async () => {
    try {
      const tokenData = parseAuthQueryString();
      if (tokenData) await handleAuthentication(tokenData);
      const token = getAccessToken();
      if (!token) throw new Error("Still no token, trying again.");
      root.render(<App />);
    } catch (e) {
      console.error(e);
      redirectToLoginPage();
    }
  })();
}
